import { Colors } from '@/common/colors/colors';
import Card from '@/common/components/Card';
import SelectInput from '@/common/components/SelectInput';
import { STATUSES_LABELS } from '@/common/constants/recruitmentStatuses';
import { useEffect, useState } from 'react';
import { ButtonWrapper } from '../RecruitmentManager.styled';
import ActionButton from '@/common/components/buttons/ActionButton';

const RecruitmentManagerSearchBar = ({
	setShowCandidateForm,
	setVisibleCandidates,
	candidates,
}) => {
	const [selectedStatus, setSelectedStatus] = useState();

	const statusOptions = [{ label: 'None', value: null }, ...STATUSES_LABELS];

	const handleFilterStatus = (value) => {
		setSelectedStatus(value);
		setVisibleCandidates(
			candidates.filter(
				(candidate) => !value?.value || candidate.status === value.value,
			),
		);
	};

	useEffect(() => {
		handleFilterStatus(selectedStatus);
	}, [candidates]);

	return (
		<div style={{ display: 'flex', justifyContent: 'center' }}>
			<Card>
				<SelectInput
					name='Status'
					options={statusOptions}
					color={Colors.darkBlue}
					width={50}
					selected={selectedStatus}
					setSelected={handleFilterStatus}
				/>
				<ButtonWrapper>
					<ActionButton
						onClick={() => setShowCandidateForm(true)}
						defaultText='Add candidate'
					/>
				</ButtonWrapper>
			</Card>
		</div>
	);
};

export default RecruitmentManagerSearchBar;
